import objetoGrupo from "../DadosFixos/grupoFarmacia.js";
export function obterNomeGrupoPorIdGia(idGia) {

    for (const item of objetoGrupo.grupos) {
        if (item.idsGia.includes(idGia)) {
            return item.nome;
        }
    } return "Nenhum";

}
